import {useMutation} from "@tanstack/react-query";
import {removeUserRoleMutationOptions} from "./remove-user-role.mutation-options";

export function useRemoveUserRole(userId: string) {
  return useMutation(removeUserRoleMutationOptions(userId));
}
